import { Box, Typography, useTheme } from '@mui/material';
import React, { useState } from "react";
import "./components.css";

function ContentBox(props) {
  const theme = useTheme();
  const [isHovering, setIsHovering] = useState(false);

  const handleMouseEnter = () => {
      setIsHovering(true);
  };

  const handleMouseLeave = () => {
      setIsHovering(false);
  };

  const box1Height = isHovering ? "80%" : "100%";
  const box2Height = isHovering ? "20%" : "0%";
  const box2Top = isHovering ? "80%" : "100%";

  return (
    <a href={props.link} className='blogContent'
        onMouseEnter={handleMouseEnter} 
        onMouseLeave={handleMouseLeave}>
        <Box sx={{ height: '300px', border: '2px solid black' }}>
            <Box className='box1' sx={{
                height: box1Height,
                width: '100%',
                backgroundColor: props.color,
                alignItems: props.isHighlight ? 'center' : 'flex-end',
                display: 'flex',
                justifyContent: props.isHighlight ? 'center' : 'flex-start',
                borderBottom: '2px solid black'
            }}>
                <Box sx={{ 
                        width: props.isHighlight ? '50%' : '100%',
                        padding: props.isHighlight ? '0px' : '30px' 
                    }}>
                    <Typography 
                        variant="body1" 
                        textAlign= {props.isHighlight ? "center":"left"} 
                        style={{ 
                            fontSize: theme.typography.subtitle1.fontSize, 
                            fontFamily: theme.typography.subtitle1.fontFamily, 
                            fontWeight: theme.typography.subtitle1.fontWeightThin,
                            letterSpacing: '2px'
                    }}>
                        {props.releaseDate} - {props.author}
                    </Typography>
                    <Typography 
                        variant='h1' 
                        style={{ 
                            fontSize: theme.typography.title2.fontSize, 
                            marginTop: '10px' 
                        }} 
                        textAlign= {props.isHighlight ? "center":"left"} 
                    >
                        {props.title}
                    </Typography>
                </Box>
            </Box>
            <Box className='box2' sx={{
                height: box2Height,
                top: box2Top,
                width: '100%',
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
            }}>
                <span>
                    <Typography style={{
                        fontSize: theme.typography.subtitle1.fontSize, 
                        fontFamily: theme.typography.subtitle1.fontFamily, 
                        fontWeight: theme.typography.subtitle1.fontWeightThin,
                        letterSpacing: '2px'
                    }}>
                        { isHovering ? 'READ ARTICLE' : '' }
                    </Typography>
                </span>
            </Box>
        </Box>
    </a>
  )
}

export default ContentBox;